import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Fab,
    Grid,
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Slide,
    Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import NumberFormat from "react-number-format";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class DepreciationRateDetailsDialog extends Component {

    closeDialog = () => {
        this.props.onClose();
    }

    render() {
        const { depreciationRates } = this.props

        let depreciationRatesList;
        let recordsNotFound;
        if (depreciationRates && depreciationRates.length > 0) {
            depreciationRatesList = depreciationRates.map((depreciationRate, index) => {
                return <TableRow key={index}>
                    <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} value={depreciationRate.rate} /></TableCell>
                    <TableCell>{depreciationRate.startDate}</TableCell>
                    <TableCell>{depreciationRate.rateMonths}</TableCell>
                    <TableCell><NumberFormat displayType="text" decimalScale={6} fixedDecimalScale={true} thousandSeparator={true} value={depreciationRate.rateMonthlyAmount} /></TableCell>
                    <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={depreciationRate.rateTotalAmount} /></TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return (
            <Dialog onClose={() => this.props.onClose()} open={this.props.isOpen} TransitionComponent={Transition} fullWidth maxWidth="md">
                <DialogTitle className="dialog-header-custom" onClose={this.props.onClose}>{this.props.t("depreciation_rate_details")} </DialogTitle>
                <DialogContent>
                    <Grid container direction="row" spacing={2}>
                        <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table" size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell component="th" scope="row" width="15%">{this.props.t("rate")}</TableCell>
                                                    <TableCell component="th" scope="row" width="25%">{this.props.t("start_date")}</TableCell>
                                                    <TableCell component="th" scope="row" width="20%">{this.props.t("number_of_months")}</TableCell>
                                                    <TableCell component="th" scope="row" width="20%">{this.props.t("rate_monthly_amount")}</TableCell>
                                                    <TableCell component="th" scope="row" width="20%">{this.props.t("rate_total_amount")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {depreciationRatesList}
                                                {recordsNotFound}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={"dialog-actions-fix"}>
                    <Fab
                        title={this.props.t("edit_depreciation_rate")} onClick={() => this.props.history.push({
                            pathname: '/assetRate/' + this.props.assetId,
                            state: {
                                selectedFrom: this.props.selectedFrom,
                                selectedTo: this.props.selectedTo,
                                selectedClient: this.props.selectedClient,
                                selectedInventory: this.props.selectedInventory,
                                selectedDepreciationGroup: this.props.selectedDepreciationGroup,
                                selectedRadioButton : this.props.selectedRadioButton,
                                inactiveAssets : this.props.inactiveAssets
                            }
                        })} size="small" style={{ marginRight: 10 }} color="primary" aria-label="edit">
                        <EditIcon />
                    </Fab>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(DepreciationRateDetailsDialog);